/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../../core";
import { SheetId } from "../../../commons/types/SheetId";
import { VersionId } from "../../../commons/types/VersionId";
export const VersionsPostRequestBody = core.serialization.object({
    sheetId: SheetId.optional(),
    parentVersionId: VersionId.optional(),
});
